var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQrPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 728,
    height: 518.338,
    viewBox: "0 0 728 518.338",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#13c4fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0533b3"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-968 -338.398)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1147.717,1158.027c-1.21,3.252-3.306,7.026-5.506,7.964a8.524,8.524,0,0,0-3.534,2.567l-2.014-1.169-2.405-1.4s.057-.267.174-.7.3-1.037.541-1.705a2.329,2.329,0,0,0,.286-2.141,4.969,4.969,0,0,1,.41-4.152c.771-1.121,1.516-3.884,1.981-3.8,1.125.194-.553,3.991-.072,4.7a.831.831,0,0,0,1.081.37l.019-.01c3.156-1.388,6.984-8.868,8.678-7.859C1147.988,1151.064,1148.232,1156.642,1147.717,1158.027Z",
    transform: "translate(66.974 -471.568)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1203.509 675.45)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1141.288,1155.516l3.954,2.779a.622.622,0,0,0,.864-.151l10.128-14.411a.623.623,0,0,0-.151-.865l-3.954-2.778a.623.623,0,0,0-.865.151l-10.127,14.411A.622.622,0,0,0,1141.288,1155.516Z",
    transform: "translate(-1141.025 -1139.977)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1207.192 678.02)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1152.16,1163.122l2.317,1.629a.474.474,0,0,0,.658-.115l10.3-14.653a.473.473,0,0,0-.115-.658L1163,1147.7a.475.475,0,0,0-.658.115l-10.3,14.653A.474.474,0,0,0,1152.16,1163.122Z",
    transform: "translate(-1151.96 -1147.611)",
    fill: "#222f3e"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M951.813,1124.713s20.117,35.087,27.415,41.543l26.76-19.951a9.767,9.767,0,0,1,5.583,5.089s-16.25,33.108-32.25,34.511-38.456-39.682-38.456-39.682Z",
    transform: "translate(195.243 -454.403)",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M797.624,1786.95H786c-1.463-.795-2.767-2.613-3.179-5.326-.568-3.745-4.765-5.786-5.673-8.85s3.745-7.371,3.745-7.371l.778-1,.81-1.041,7.714,1.817s.192,1.838.307,4.178a53.388,53.388,0,0,1,.034,5.351c-.227,4.083,1.142,8.482,4.771,9.277C797.99,1784.568,797.87,1786.16,797.624,1786.95Z",
    transform: "translate(303.908 -877.995)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M984.458,1806.644H957.876c-1.279-1.56-.807-7.317-.614-9.2.04-.378.067-.6.067-.6s9.077-7.26,10.324-1.7c.038.174.084.344.135.513,1.571,5.2,8.616,7.563,12.685,8.221C983.118,1804.311,984.1,1805.686,984.458,1806.644Z",
    transform: "translate(184.531 -897.689)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M947.615,1388.1s-1.378,17.2-3,37.867c-2.2,28.08-4.85,62.571-5.112,69.105-.453,11.346-2.27,29.5-2.27,29.5s-4.309,4.312-12.932,2.495c0,0-7.685-25.909-9.879-53.321-.034-.449-.068-.9-.1-1.354-2.042-27.906-5.217-86.669-5.217-86.669Z",
    transform: "translate(216.31 -627.518)",
    fill: "#f9ae30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M947.615,1388.1s-1.378,17.2-3,37.867l-30.193,47.774c-.034-.449-.068-.9-.1-1.354-2.042-27.906-5.217-86.669-5.217-86.669Z",
    transform: "translate(216.31 -627.518)",
    fill: "#b30505",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M861.327,1376.736s-24.843,62.278-41.178,91.546-21.44,37.435-21.44,37.435-9.359-3.744-10.209-6.3c0,0,6.247-56.5,17.186-70.276,6.181-7.783,13.442-31.139,13.783-39.307s2.212-24.333,2.212-24.333Z",
    transform: "translate(296.303 -614.112)",
    fill: "#f9ae30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M934.2,1078.248c-9.708,3.063-26.506-5.2-26.506-5.2s8.951-6.718,8.482-20.686l7.506,6.049,5.1,4.109a61.078,61.078,0,0,1-.578,6.668c-.147,1.117,1.113,3.579,2.2,4.964C933.353,1077.881,934.2,1078.248,934.2,1078.248Z",
    transform: "translate(217.243 -406.412)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M945.429,1074.143a61.044,61.044,0,0,1-.578,6.668c-5.65-.969-12.058-10.1-12.058-10.1a18,18,0,0,1,7.538-.675Z",
    transform: "translate(200.598 -418.04)",
    fill: "#ed975d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M941.356,1029.587s-16.035,2.664-17.54-7.348-4.589-16.411,5.586-18.535,12.743,1.4,14.058,4.616S945.489,1028.636,941.356,1029.587Z",
    transform: "translate(207.639 -373.714)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M930.319,1201.561a1.571,1.571,0,0,1-1.02.389c-3.646-.05-14.277,1.975-23.272,1.052-7.583-.728-14.3-2.974-21.5-6.205-.957-.429-3.16-1.6-3.11-2.675.032-1.171.149-2.87.295-5.01a268.018,268.018,0,0,0,.532-35c-.156-2.749-.238-5.476-.247-8.161-.074-20.009,3.893-37.607,11.865-43.564.681-.488,4.862,1.555,8.7,3.45a15.894,15.894,0,0,0,10.451,1.265l3.354,2.965c4.084,3.792,8.556,8.945,10.5,16.772,1.654,6.66,2.625,18.668,3.16,31.114.243,5.64.438,11.328.488,16.725v.193c.047.535.047,1.12.047,1.654C930.758,1190.379,930.562,1201.365,930.319,1201.561Z",
    transform: "translate(234.676 -439.546)",
    fill: "#0533b3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M882.29,1247.686a268.014,268.014,0,0,0,.532-35c-.156-2.749-.238-5.476-.247-8.161,3.321-8.056,6.035-13.9,6.035-13.9h8.371S903.118,1232.546,882.29,1247.686Z",
    transform: "translate(234.094 -498.121)",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1066.175 764.62)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M740.513,1437.237l35.7,5.088a8.559,8.559,0,0,0,9.652-7.245l2.2-15.471a8.559,8.559,0,0,0-7.245-9.652l-35.7-5.088a8.559,8.559,0,0,0-9.652,7.245l-2.2,15.472A8.559,8.559,0,0,0,740.513,1437.237Z",
    transform: "translate(-733.183 -1404.783)",
    fill: "url(#a)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1061.445 759.98)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M773.526,1405.431v0a8.6,8.6,0,0,0-5.915-5.167h0a.008.008,0,0,1-.006,0c-.269-.065-.542-.12-.824-.16l-7.109-1.011.475-3.339a2.828,2.828,0,0,0-2.4-3.2l-1.854-.265-7.464-1.064-1.346-.191a2.829,2.829,0,0,0-3.2,2.4l-.475,3.339-12.271-1.749a8.593,8.593,0,0,0-9.689,7.271l-2.228,15.652a8.589,8.589,0,0,0,7.27,9.687l35.637,5.08a8.362,8.362,0,0,0,1.859.059h.006a8.433,8.433,0,0,0,2.782-.7,8.58,8.58,0,0,0,5.042-6.629l2.231-15.65A8.493,8.493,0,0,0,773.526,1405.431Zm-27.887-11.747a1.059,1.059,0,0,1,1.194-.9l1.585.225,5.875.839,3.2.457a1.056,1.056,0,0,1,.9,1.192l-.475,3.339-12.752-1.819Z",
    transform: "translate(-719.136 -1391.006)",
    fill: "#222f3e"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M814.224,1359.545s-1.875,2.5-1.949,3.495c-.5,6.764,2.586,7.7-5.415,11.457,0,0-3.416,1.3-3.474-1.349s2.371-2.7,1.927-6.408c-.512-4.282-.461-4.322,2.35-6.559l1.861-3.076Z",
    transform: "translate(286.43 -608.54)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M813.252,1195.23a27.439,27.439,0,0,0,6.282.35s8.949-27.645,10.1-30.17,26.582-32.416,26.582-32.416l-10.594-26.512s-27.505,45.944-30.3,52.4c-4.615,10.668-6.217,34.586-6.217,34.586A11.514,11.514,0,0,0,813.252,1195.23Z",
    transform: "translate(282.633 -442.311)",
    fill: "#0533b3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M919.322,1007.054s1.646-.275,1.38-2.542-.262-5.229,1.581-4.677,1.934,2.027,2.692,1.166.771-4.492,6.254-4.744,7.711,1.656,10.261.535,2.684-4.981,2.684-4.981a4.387,4.387,0,0,1-1.82,1.816s4.254-5.818-.671-9.808-9.947-1.378-12.8-1.205c-6.28.38-10.336.757-12.388,4.883S915.292,1003.081,919.322,1007.054Z",
    transform: "translate(212.12 -359.491)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M826.473,1373.185s1.805,1.882,1.919,2.665c.366,2.514,1.2,3.6.784,3.873-.874.568-2.031-1.293-2.584-2.962A7.633,7.633,0,0,1,826.473,1373.185Z",
    transform: "translate(271.223 -619.206)",
    fill: "#ffb27d"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -54)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 213.86,
    height: 372.912,
    rx: 19,
    transform: "translate(1236.581 533.175)",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1428.374,1087.964H1254.159a22.336,22.336,0,0,1-22.311-22.311V732.386a22.336,22.336,0,0,1,22.311-22.31h174.215a22.336,22.336,0,0,1,22.31,22.31v333.267A22.336,22.336,0,0,1,1428.374,1087.964ZM1254.159,715.052a17.354,17.354,0,0,0-17.335,17.334v333.267a17.354,17.354,0,0,0,17.335,17.335h174.215a17.354,17.354,0,0,0,17.334-17.335V732.386a17.354,17.354,0,0,0-17.334-17.334Z",
    transform: "translate(2.245 -179.389)",
    fill: "#2b478b"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(42 -54)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1422.591 758.554)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1818.022,1387.448a18.448,18.448,0,0,1,18.388,5.249c11.322,12.3,2.974,21.775,8.641,30.383,3.424,5.2,6.3,14.309-4.308,19.7-4.9,2.491-19.515,15.51-22.505,15.818-30.317,3.113-30.861-27.642-20.642-36.555C1811.957,1409.513,1798.835,1393.045,1818.022,1387.448Z",
    transform: "translate(-1791.63 -1386.771)",
    fill: "#233862"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1458.7 806.779)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1904.99,1529.984s27.667,13.4,32.85,13.177,37.577-11.634,37.577-11.634l-.813,5.494s-24.645,14.174-33.261,14.978c-8.483.792-37.488-7.613-40.289-9.388S1896.852,1531.78,1904.99,1529.984Z",
    transform: "translate(-1898.863 -1529.984)",
    fill: "#ed985f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1435.679 789.474)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1862.691,1508.542a27.467,27.467,0,0,1-9.6,4.085c-14.8,3.418-20.465-9.086-22.595-17.67a12.724,12.724,0,0,1,5.013-1.54c1.07-.126,2.194-.21,3.126-.256,1.661-1.273,4.137-6.481,4.684-14.567l.7.187,11.661,3.191s-.534,3.707-.8,7.21c-.2,2.742-.234,5.362.285,6,.91.2,1.456.326,1.456.326a.025.025,0,0,0,.006.011A75.107,75.107,0,0,1,1862.691,1508.542Z",
    transform: "translate(-1830.498 -1478.594)",
    fill: "#ffb27d"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1449.198 789.663)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1882.3,1482.347s-.536,3.7-.8,7.21c-6.606-.661-9.672-6.951-10.865-10.4Z",
    transform: "translate(-1870.643 -1479.156)",
    fill: "#ed985f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1447.818 769.411)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1881.559,1445.935s-15.68-.865-14.991-10.622-.87-16.439,9.17-16.3,11.72,4,12.282,7.312S1885.655,1445.909,1881.559,1445.935Z",
    transform: "translate(-1866.545 -1419.013)",
    fill: "#ffb27d"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1442.918 767.401)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1878.294,1416.909c-2.211-3.108-4.086-2.6-5.174-1.786a10.976,10.976,0,0,0-14.239,1.242,18.682,18.682,0,0,1-6.885,10.573s2.779,2.222,9.43.748a16.642,16.642,0,0,0,11.829-10.4c.894.927,2.05,1.517,2.936,3.528a15.464,15.464,0,0,1,1.733,7.7S1881.609,1421.571,1878.294,1416.909Z",
    transform: "translate(-1851.996 -1413.042)",
    fill: "#233862"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1800.157,1565.878c-1.416-7.238-6.033-36.159-1.416-45.465,1.658-3.343,8.165-3.645,15.3-3.352,2.221,1.434,10.686,6.854,14.162,6.177.037-.007.105-.023.195-.045,1.637-.41,2.255-1.56.89-2.552a72.089,72.089,0,0,1,7.525,1.048c2.48.467,9.29,4.647,9.29,4.647a20.282,20.282,0,0,1-8.055,6.9c.844,7.556-.411,10.889-8.249,28.34-6.624,14.751.893,28.032.893,28.032s-38.989,31.348-39.206,15.387C1791.326,1592.983,1801.967,1575.13,1800.157,1565.878Z",
    transform: "translate(-368.944 -714.576)",
    fill: "#f9ae30"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1439.77 823.364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1866.559,1664.994a7.249,7.249,0,0,0,5.215-3.174q.282-.423.6-.908c4.438-6.719,6.165-27.294,16.148-49.213,2.432-5.336,11.16-6.3,13.54-12.329,0,0,5.857-19.553-11.212-20.129s-45.716,54.4-46.168,60.171C1844.246,1645,1833.4,1668.736,1866.559,1664.994Z",
    transform: "translate(-1842.645 -1579.236)",
    fill: "url(#a)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1506.976 896.068)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2066.781,1808.087h-24.3s-.908-3.978.687-6.686c1.412-2.4.871-3.76-.175-5.742a9.224,9.224,0,0,0,4.092.791,8.42,8.42,0,0,0,3.613-1.3c1.045,1.224,5.523,6.434,6.922,7.466C2059.212,1803.783,2066.291,1803.366,2066.781,1808.087Z",
    transform: "translate(-2042.227 -1795.146)",
    fill: "#222f3e"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1478.693 822.591)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1979.286,1583.371c1.463,10.968,7.176,45.585,17.253,62.475,3.25,5.444-8.185,8.5-8.247,8.481-1.534-.4-4.089-2.847-5.266-3.907-8.181-7.374-24.791-28.254-24.791-44.993,0-8.162-.143-23.75,5.792-27.712C1967.682,1575.275,1978.705,1579.015,1979.286,1583.371Z",
    transform: "translate(-1958.235 -1576.942)",
    fill: "url(#a)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1432.167 814.56)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1820.068,1557.938s4.931,10.03,27.946,17.117,9.851-10.719,9.851-10.719l-32.176-11.244Z",
    transform: "translate(-1820.068 -1553.092)",
    fill: "#b30505"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1422.016 822.117)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1819.727,1662.563a17.908,17.908,0,0,0,2.012-4.589c1.306-4.583,1.77-7.918,4.279-15.057,2.635-7.494,5.761-16.715,9.668-26.308,1.205-2.961,2.486-5.958,3.848-8.951,2.432-5.336,9.121-4.6,11.5-10.632,0,0,9.286-20.913-7.784-21.49s-49.506,55.944-51.37,61.418C1789.84,1642.946,1782.508,1668.3,1819.727,1662.563Z",
    transform: "translate(-1789.922 -1575.532)",
    fill: "#0533b3"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1489.141 896.068)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2013.817,1808.087h-24.3s-.908-3.978.687-6.686c1.412-2.4.871-3.76-.174-5.742a9.223,9.223,0,0,0,4.092.791,8.414,8.414,0,0,0,3.613-1.3c1.045,1.224,5.523,6.434,6.922,7.466C2006.248,1803.783,2013.328,1803.366,2013.817,1808.087Z",
    transform: "translate(-1989.263 -1795.146)",
    fill: "#222f3e"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1455.91 847.004)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1892.778,1691.938c2.635-7.494,5.761-16.715,9.668-26.308-1.02-7.268-3.221-13.627-6.922-16.19C1895.525,1649.44,1886.546,1677.255,1892.778,1691.938Z",
    transform: "translate(-1890.577 -1649.44)",
    fill: "#88e1fd"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1460.859 823.026)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1929.976,1583.451c1.463,10.968,3.523,46.362,13.6,63.252,3.249,5.444-8.186,8.5-8.247,8.481-1.534-.4-4.089-2.846-5.266-3.907-8.182-7.374-24.791-28.253-24.791-44.993,0-8.162,9.579-23.1,15.514-27.057A5.97,5.97,0,0,1,1929.976,1583.451Z",
    transform: "translate(-1905.273 -1578.234)",
    fill: "#0533b3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2064.772,1487.371l-24.881-2.643a1.606,1.606,0,0,0-1.671,1.026l-8.9,23.392a1.606,1.606,0,0,0,1.437,2.176l24.689,1a1.607,1.607,0,0,0,1.547-.985l9.094-21.745A1.607,1.607,0,0,0,2064.772,1487.371Z",
    transform: "translate(-526.619 -693.183)",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2071.191,1488.043l-24.88-2.643a1.606,1.606,0,0,0-1.671,1.026l-8.9,23.392a1.606,1.606,0,0,0,1.437,2.176l24.689,1a1.606,1.606,0,0,0,1.546-.985l9.094-21.745A1.606,1.606,0,0,0,2071.191,1488.043Z",
    transform: "translate(-530.876 -693.628)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2094.131,1522.723a1.023,1.023,0,0,0-.961-1.512,2.393,2.393,0,0,0-2.062,1.512,1.023,1.023,0,0,0,.962,1.511A2.39,2.39,0,0,0,2094.131,1522.723Z",
    transform: "translate(-567.606 -717.386)",
    fill: "#ebf3fa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2136,1498.368a.5.5,0,0,0-.473-.743,1.175,1.175,0,0,0-1.013.743.5.5,0,0,0,.472.743A1.176,1.176,0,0,0,2136,1498.368Z",
    transform: "translate(-596.432 -701.742)",
    fill: "#ebf3fa"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1429.797 805.836)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1818.911,1527.185s34.484,12.7,39.665,12.439c3.349-.168,31.186-9.953,31.186-9.953l2.5,4.727s-27.094,17.414-34.542,17.328c-14.705-.17-39.518-9.2-42.319-10.971S1810.773,1528.982,1818.911,1527.185Z",
    transform: "translate(-1813.028 -1527.185)",
    fill: "#ffb27d"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1506.53 804.359)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2040.9,1526.76s2.5-3.845,4.987-3.959,6.786,1.7,8.256,1.98,5.655,1.64,4.411,3.675-7.013,2.488-9.5,2.036-5.655.995-5.655.995Z",
    transform: "translate(-2040.902 -1522.796)",
    fill: "#ffb27d"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1510.84 802.202)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2053.7,1518.673s3.957-1.815,5.089-2.154.9.005.565,1.077-2.375,2.095-2.375,2.431S2053.7,1518.673,2053.7,1518.673Z",
    transform: "translate(-2053.701 -1516.393)",
    fill: "#ffb27d"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1533.421 802.402)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2125.092,1520.87s-1.579-5.2-3.312-3.567c-1.8,1.7-.709,3.4-.488,5.57.422,4.146,1.26,3.967,1.791,3.78S2125.678,1522.955,2125.092,1520.87Z",
    transform: "translate(-2120.76 -1516.985)",
    fill: "#ffb27d"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1534.44 807.078)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2127.194,1530.873a6.605,6.605,0,0,1-3.407,6.738l1.245-3.047Z",
    transform: "translate(-2123.787 -1530.873)",
    fill: "#ffb27d"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1460.113 790.37)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1908.713,1481.607s-1.483-.587-5.654-.249c0,0,.221,1.627,3.3,1.788A2.453,2.453,0,0,0,1908.713,1481.607Z",
    transform: "translate(-1903.059 -1481.253)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1428.556 805.036)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1834.234,1531.871s-3.084,9.763-13.676,11.985c0,0-17.492-5.389-8.782-17.306C1811.776,1526.55,1820.386,1520.152,1834.234,1531.871Z",
    transform: "translate(-1809.344 -1524.807)",
    fill: "#f9ae30"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1537.424 804.37)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2133.07,1526.163s.727-2.436.769-2.859-.009-.634-.385-.338a2.045,2.045,0,0,0-.777,1.817C2132.847,1525.522,2133.07,1526.163,2133.07,1526.163Z",
    transform: "translate(-2132.647 -1522.829)",
    fill: "#ffb27d"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -54)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1309.977 566.198)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1457.844,837.931a2.5,2.5,0,0,0-.445,2.67.023.023,0,0,0,.007.013c.644,1.78,2.772,3.767,5.244,5.752.316.255.6.487.841.7.064.056.129.113.189.169s.1.089.146.131c2.3,2.124,1.438,2.611,5.578,6.923,4.721,4.912,7.972,5,8.9,4.553.783-.381-.807-2.987-2.568-5.915-.085-.141-.169-.284-.257-.427-.235-.389-.468-.784-.7-1.176-2.064-3.524-1.534-5.178-1.045-10.423.4-4.262,6.631-23.812,6.631-23.812l-9.048-1.559s-2.725,15.567-5.727,17.964c-1.606,1.278-3.4,1.294-4.945,2.241q-.164.1-.321.2A11.88,11.88,0,0,0,1457.844,837.931Z",
    transform: "translate(-1457.201 -815.533)",
    fill: "#ffc49c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1309.977 586.404)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1457.844,877.73a2.5,2.5,0,0,0-.445,2.67.023.023,0,0,0,.007.013c.789,1.778,2.863,3.755,5.252,5.734.312.259.588.5.833.72.064.056.129.113.189.169s.1.089.146.131c2.3,2.124,1.438,2.611,5.578,6.923,4.721,4.912,7.972,5,8.9,4.553.783-.382-.807-2.987-2.568-5.916a20.113,20.113,0,0,1-8.416-6.2c-2.843-3.628-4.739-8.289-6.675-10.989q-.164.1-.321.2A11.88,11.88,0,0,0,1457.844,877.73Z",
    transform: "translate(-1457.201 -875.538)",
    fill: "url(#a)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1376.341 563.444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1661.518,826.856c.559,2.793,4.539,2.327,8.987,1.24s3.391.205,9.721-.5,8.248-3.061,8.441-4c.172-.835-2.955-1.13-6.311-1.516-.422-.047-.845-.1-1.269-.152-3.788-.475-6.562-2.92-10-4.927-3.259-1.9-8.123-9.648-8.123-9.648l-8.681.688s4.556,6.919,6.318,9.927c1.036,1.77.981,4.109.852,5.916A11.142,11.142,0,0,0,1661.518,826.856Z",
    transform: "translate(-1654.281 -807.355)",
    fill: "#ffc49c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1383.444 578.172)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1684.5,857.1c4.448-1.087,3.391.205,9.72-.5s8.248-3.061,8.441-4c.172-.835-2.955-1.13-6.31-1.516l-.031.064a17.847,17.847,0,0,1-9.065,2.818c-4.295.1-8.844-1.126-11.81-1.078a11.142,11.142,0,0,0,.067,2.97C1676.068,858.656,1680.049,858.191,1684.5,857.1Z",
    transform: "translate(-1675.376 -851.09)",
    fill: "url(#a)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1320.526 513.52)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1518.311,673.01l-8.116,21.838L1499.6,723.361a17.162,17.162,0,0,1-5.629-.514,24.41,24.41,0,0,1-5.444-2.65s2.942-30.615,8.43-48.19c1.406-4.511,2.982-8.16,4.722-10.214C1510.188,651.739,1518.311,673.01,1518.311,673.01Z",
    transform: "translate(-1488.528 -659.094)",
    fill: "#f29c2b"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1264.478 488.394)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1399.663,588.84c-5.064-1.634-19.062.287-33.543,3.049a3.189,3.189,0,0,1-3.323-1.481l-2.037-3.36-32.9-2.569s-8.492,19.3-4.881,35.347c.885,3.932,5.694,9.026,13.046,9.483,20.609,1.282,34.511-5.875,55.9-13.4,3.721-1.308,5.415,6.962,9.282,15.084s36.356,35.969,36.356,35.969,4.993.049,7.056-.724a6.949,6.949,0,0,0,3.03-1.913S1411.652,592.708,1399.663,588.84Z",
    transform: "translate(-1322.083 -584.479)",
    fill: "#f9ae30"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1246.091 392.398)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1323.249,302.161c-4.215-2.213-10.628-2.513-11.67-2.652-12.468-1.676-19.971,16.441-20.412,21.931-.814,10.118-6.166,11.661-13.7,18-15.107,12.706-10.677,27.471-2.416,32.956,4.956,3.292,13.692,0,13.692,0,.124.086,23.892-13.287,35.608-19.738C1341.914,350.158,1333.989,307.8,1323.249,302.161Z",
    transform: "translate(-1267.479 -299.399)",
    fill: "#222f3e"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1277.112 421.739)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1375.631,404.957c.052.033-5.765,2.019-9.654.3-3.659-1.617-6.43-7.636-6.376-7.639,1.664-.077,3.491-1.532,4.9-11.08l.709.254,11.916,4.288s-.864,3.824-1.422,7.464C1375.233,401.6,1374.98,404.525,1375.631,404.957Z",
    transform: "translate(-1359.601 -386.535)",
    fill: "#ffb27d"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1282.72 421.994)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1388.171,391.578s-.6,2.714-1.255,6.425c-6.844-1.232-9.7-7.012-10.661-10.712Z",
    transform: "translate(-1376.255 -387.29)",
    fill: "#ed975d"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1281.526 401.399)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1387.594,354.807s-16.3-2.188-14.784-12.32.438-17.238,10.911-16.269,11.911,5.137,12.227,8.643S1391.874,355.115,1387.594,354.807Z",
    transform: "translate(-1372.71 -326.13)",
    fill: "#ffb27d"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1276.848 400.503)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1386.14,327.542s-10.436,8.994-17.535,9.719-9.787-1.554-9.787-1.554a27.719,27.719,0,0,0,6.7-9.081,4.992,4.992,0,0,1,4.115-2.943C1374.7,323.247,1384.313,323.047,1386.14,327.542Z",
    transform: "translate(-1358.818 -323.469)",
    fill: "#222f3e"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1297.646 401.82)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1420.582,329.331s3.491,3.376,4.591,5.88c1.061,2.416,1.379,8.2.534,10.491,0,0,5.44-10.578,2.36-15.716C1424.8,324.536,1420.582,329.331,1420.582,329.331Z",
    transform: "translate(-1420.582 -327.381)",
    fill: "#233862"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1263.12 432.435)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1361.8,450.04c1.25,29.428-.728,27.805-3.745,29.237a19.32,19.32,0,0,1-6.534,1.416c-10.119.671-27.908-1-28.585-2.866-2.334-6.471-.686-8.481-2.634-18.388-.2-1.054-.454-2.194-.749-3.436-1.624-6.8-3.2-9.119,2.556-20.051,5.224-9.9,10.651-17.939,11.139-17.649,13.782,8.182,14.894,1.3,14.894,1.3S1361.117,433.955,1361.8,450.04Z",
    transform: "translate(-1318.051 -418.296)",
    fill: "#0533b3"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1320.526 526.433)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1510.2,720.282,1499.6,748.8a17.162,17.162,0,0,1-5.629-.514,24.408,24.408,0,0,1-5.444-2.65s2.942-30.615,8.43-48.189Z",
    transform: "translate(-1488.528 -697.442)",
    fill: "#f9ae30"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1293.214 433.745)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1407.419,422.189s14.182,2.4,15.847,8.51,11.465,42,11.465,42-7.209,1.3-10.54-2.036-11.589-30.9-11.589-30.9Z",
    transform: "translate(-1407.419 -422.189)",
    fill: "#0533b3"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1265.373 459.834)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1355.958,534.661c-10.119.671-27.908-1-28.585-2.866-2.334-6.471-.686-8.481-2.634-18.388l4.881-13.744s-.807,15.3,3.707,19.33,18.48,7.771,20.674,11.134A12.319,12.319,0,0,1,1355.958,534.661Z",
    transform: "translate(-1324.739 -499.663)",
    fill: "url(#a)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1284.997 486.848)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1383.017,581.434s9.984-2.223,11.594-1.337,5.548,4.113,6.041,5.236-3.586-.853-4.913-1.208c-.859-.231-3.121.555-4.241.929-4.712,1.57-7.6.763-7.6.763Z",
    transform: "translate(-1383.017 -579.889)",
    fill: "#ffb27d"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1245.97 432.435)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1299.461,418.3s-13.405.826-18.046,7.3c-6.532,9.111-19.491,47.94-12.064,53.119,8.364,5.832,38.065,1.526,38.065,1.526s.988-4.62-.387-6.855-23.723-5.845-24.754-6.876,12.893-20.113,12.893-23.207S1299.461,418.3,1299.461,418.3Z",
    transform: "translate(-1267.121 -418.298)",
    fill: "#0533b3"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1297.074 489.836)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1418.884,588.76a19.312,19.312,0,0,0,2.778,3.021,2.046,2.046,0,0,0,1.128.241l-1.409-2.537Z",
    transform: "translate(-1418.884 -588.76)",
    fill: "#ffb27d"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1296.591 487.057)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1417.449,580.508l6.082,2.953a1.084,1.084,0,0,1-1.007.389,14.516,14.516,0,0,1-2.638-.725Z",
    transform: "translate(-1417.449 -580.508)",
    fill: "#ffb27d"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1284.997 461.002)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.855)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1427.133,539.12h48.109l14.472-35.988h-48.035Z",
    transform: "translate(-1427.133 -503.132)",
    fill: "#222f3e"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 34.586)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1446.545,605.841h-63.528v1.4h62.964Z",
    transform: "translate(-1383.017 -605.841)",
    fill: "#222f3e"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1331.143 476.705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1524.73,552.057a1.667,1.667,0,0,0-1.634-2.291,3.282,3.282,0,0,0-2.947,2.291,1.667,1.667,0,0,0,1.634,2.291A3.282,3.282,0,0,0,1524.73,552.057Z",
    transform: "translate(-1520.056 -549.766)",
    fill: "#ebf3fa"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M1.08,0H726.92A1.08,1.08,0,0,1,728,1.08v0a1.08,1.08,0,0,1-1.08,1.08H1.08A1.08,1.08,0,0,1,0,1.08v0A1.08,1.08,0,0,1,1.08,0Z",
    transform: "translate(968 854.576)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1602.62 748.162)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-345.177,1916.047s32.14-48.467,0-106.455c0,0-51.952,38.477-33.266,106.455Z",
    transform: "translate(398.232 -1809.592)",
    fill: "#a9dcb5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-379.752,1876.439c.038-.345.075-.691.116-1.033a142.709,142.709,0,0,0,17.874,21.273c1.508-11.9,3.51-24.244,5.749-35.993l-.027.018a221.408,221.408,0,0,1-12.355-20.285c.132-.243.264-.482.4-.721a220.591,220.591,0,0,0,12.161,20.067c3.9-20.323,8.5-38.76,12.438-49.873.25-.2.388-.3.388-.3.091.164.174.326.264.489-3.91,10.991-8.477,29.289-12.367,49.5,9.173-6.981,17.08-13.353,23.895-19.261.057.255.117.512.172.767-6.916,5.982-14.939,12.435-24.261,19.513-2.268,11.894-4.295,24.408-5.811,36.459a175.77,175.77,0,0,0,30.434-13.873q-.088.452-.179.9a176.131,176.131,0,0,1-30.351,13.741c-.777,6.257-1.415,12.379-1.875,18.217h-.691c.468-5.928,1.119-12.153,1.913-18.512A140.346,140.346,0,0,1-379.752,1876.439Z",
    transform: "translate(396.067 -1809.592)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-448.466,2078.614s-18.977-28.618,0-62.858c0,0,30.676,22.719,19.643,62.858Z",
    transform: "translate(456.901 -1972.159)",
    fill: "#f9ae30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-422.46,2055.226c-.022-.2-.044-.408-.069-.61a84.25,84.25,0,0,1-10.554,12.562c-.89-7.027-2.072-14.315-3.394-21.253l.016.011a130.674,130.674,0,0,0,7.3-11.978c-.078-.143-.156-.285-.234-.426a130.313,130.313,0,0,1-7.18,11.849c-2.305-12-5.018-22.887-7.344-29.449-.148-.115-.229-.176-.229-.176-.054.1-.1.192-.156.289,2.309,6.49,5.005,17.294,7.3,29.229-5.416-4.122-10.085-7.884-14.109-11.373-.033.151-.069.3-.1.453,4.084,3.532,8.821,7.342,14.325,11.521,1.339,7.023,2.536,14.413,3.431,21.528a103.776,103.776,0,0,1-17.97-8.192c.035.179.07.355.106.531a103.985,103.985,0,0,0,17.922,8.114c.459,3.695.836,7.31,1.107,10.757h.408c-.276-3.5-.661-7.176-1.13-10.931A82.883,82.883,0,0,0-422.46,2055.226Z",
    transform: "translate(452.588 -1972.159)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -54)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 140.661,
    height: 140.661,
    transform: "translate(1273.18 631.302)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1287.28 757.202)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1292.87 757.202)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1298.46 757.202)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1304.05 757.202)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1309.64 757.202)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1320.82 757.202)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1326.41 757.202)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1343.18 757.202)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.921,
    height: 5.59,
    transform: "translate(1354.36 757.202)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1360.281 757.202)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1371.461 757.202)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1377.051 757.202)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1382.641 757.202)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1388.231 757.202)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1393.82 757.202)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.92,
    height: 5.59,
    transform: "translate(1399.411 757.202)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1281.69 757.202)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1309.64 751.612)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1326.41 751.612)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1337.59 751.612)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1343.18 751.612)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1348.77 751.612)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.921,
    height: 5.59,
    transform: "translate(1354.36 751.612)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1371.461 751.612)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.92,
    height: 5.59,
    transform: "translate(1399.411 751.612)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1281.69 751.612)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1292.87 746.022)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1298.46 746.022)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1309.64 746.022)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1320.82 746.022)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1326.41 746.022)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1332 746.022)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1343.18 746.022)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1348.77 746.022)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.921,
    height: 5.59,
    transform: "translate(1354.36 746.022)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1360.281 746.022)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1371.461 746.022)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1382.641 746.022)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1388.231 746.022)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.92,
    height: 5.59,
    transform: "translate(1399.411 746.022)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1281.69 746.022)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1292.87 740.432)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1298.46 740.432)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1309.64 740.432)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1320.82 740.432)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1332 740.432)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1343.18 740.432)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1371.461 740.432)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1382.641 740.432)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1388.231 740.432)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.92,
    height: 5.59,
    transform: "translate(1399.411 740.432)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1281.69 740.432)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1309.64 734.842)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1320.82 734.842)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1326.41 734.842)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1332 734.842)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1343.18 734.842)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1348.77 734.842)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1360.281 734.842)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1371.461 734.842)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.92,
    height: 5.59,
    transform: "translate(1399.411 734.842)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1281.69 734.842)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1287.28 729.252)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1292.87 729.252)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1298.46 729.252)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1304.05 729.252)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1309.64 729.252)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1320.82 729.252)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1332 729.252)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1337.59 729.252)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1348.77 729.252)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1371.461 729.252)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1377.051 729.252)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1382.641 729.252)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1388.231 729.252)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1393.82 729.252)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.92,
    height: 5.59,
    transform: "translate(1399.411 729.252)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1281.69 729.252)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1337.59 723.662)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1343.18 723.662)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1348.77 723.662)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1360.281 723.662)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1287.28 718.072)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1292.87 718.072)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1298.46 718.072)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1304.05 718.072)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1320.82 718.072)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1326.41 718.072)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1332 718.072)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1343.18 718.072)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1348.77 718.072)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.921,
    height: 5.59,
    transform: "translate(1354.36 718.072)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1360.281 718.072)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1365.871 718.072)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1371.461 718.072)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1377.051 718.072)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1382.641 718.072)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1393.82 718.072)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.92,
    height: 5.59,
    transform: "translate(1399.411 718.072)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1292.87 712.482)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1298.46 712.482)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1315.23 712.482)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1320.82 712.482)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1332 712.482)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1348.77 712.482)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1360.281 712.482)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1365.871 712.482)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1377.051 712.482)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1382.641 712.482)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1287.28 706.892)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1298.46 706.892)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1304.05 706.892)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1309.64 706.892)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1315.23 706.892)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1326.41 706.892)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1332 706.892)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1337.59 706.892)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1343.18 706.892)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1348.77 706.892)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.921,
    height: 5.59,
    transform: "translate(1354.36 706.892)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1382.641 706.892)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1388.231 706.892)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.92,
    height: 5.59,
    transform: "translate(1399.411 706.892)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1281.69 706.892)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1287.28 701.302)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1292.87 701.302)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1298.46 701.302)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1320.82 701.302)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1326.41 701.302)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1348.77 701.302)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1365.871 701.302)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1371.461 701.302)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1382.641 701.302)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1388.231 701.302)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1393.82 701.302)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.92,
    height: 5.59,
    transform: "translate(1399.411 701.302)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1281.69 701.302)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1298.46 695.712)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1304.05 695.712)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1309.64 695.712)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1315.23 695.712)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1320.82 695.712)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1326.41 695.712)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1343.18 695.712)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1360.281 695.712)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1365.871 695.712)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1388.231 695.712)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1281.69 695.712)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1287.28 690.122)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1292.87 690.122)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1298.46 690.122)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1304.05 690.122)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1315.23 690.122)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1326.41 690.122)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1332 690.122)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1343.18 690.122)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1348.77 690.122)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.921,
    height: 5.59,
    transform: "translate(1354.36 690.122)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1360.281 690.122)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1371.461 690.122)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1377.051 690.122)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1382.641 690.122)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1388.231 690.122)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.92,
    height: 5.59,
    transform: "translate(1399.411 690.122)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1287.28 684.532)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1298.46 684.532)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1309.64 684.532)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1315.23 684.532)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1332 684.532)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1337.59 684.532)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1343.18 684.532)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.921,
    height: 5.59,
    transform: "translate(1354.36 684.532)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1360.281 684.532)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1365.871 684.532)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1377.051 684.532)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1388.231 684.532)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1393.82 684.532)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.92,
    height: 5.59,
    transform: "translate(1399.411 684.532)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1281.69 684.532)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1287.28 678.942)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1309.64 678.942)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1315.23 678.942)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1326.41 678.942)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1332 678.942)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1343.18 678.942)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1348.77 678.942)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1360.281 678.942)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1365.871 678.942)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1371.461 678.942)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1377.051 678.942)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1382.641 678.942)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1388.231 678.942)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1281.69 678.942)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1326.41 673.352)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1337.59 673.352)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1343.18 673.352)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.921,
    height: 5.59,
    transform: "translate(1354.36 673.352)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1360.281 673.352)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1365.871 673.352)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1287.28 667.762)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1292.87 667.762)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1298.46 667.762)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1304.05 667.762)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1309.64 667.762)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1320.82 667.762)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1326.41 667.762)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1343.18 667.762)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1365.871 667.762)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1371.461 667.762)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1382.641 667.762)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.92,
    height: 5.59,
    transform: "translate(1399.411 667.762)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1281.69 667.762)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1309.64 662.172)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.921,
    height: 5.59,
    transform: "translate(1354.36 662.172)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1360.281 662.172)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1371.461 662.172)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1377.051 662.172)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1388.231 662.172)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1393.82 662.172)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.92,
    height: 5.59,
    transform: "translate(1399.411 662.172)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1281.69 662.172)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1292.87 656.582)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1298.46 656.582)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1309.64 656.582)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1320.82 656.582)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1326.41 656.582)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1337.59 656.582)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1343.18 656.582)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.921,
    height: 5.59,
    transform: "translate(1354.36 656.582)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1377.051 656.582)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1382.641 656.582)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1388.231 656.582)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1281.69 656.582)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1292.87 650.992)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1298.46 650.992)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1309.64 650.992)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1320.82 650.992)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1332 650.992)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1337.59 650.992)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1343.18 650.992)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1348.77 650.992)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.921,
    height: 5.59,
    transform: "translate(1354.36 650.992)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1365.871 650.992)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1371.461 650.992)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1377.051 650.992)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1388.231 650.992)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1393.82 650.992)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.92,
    height: 5.59,
    transform: "translate(1399.411 650.992)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1281.69 650.992)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1309.64 645.402)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1332 645.402)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1337.59 645.402)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1348.77 645.402)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.921,
    height: 5.59,
    transform: "translate(1354.36 645.402)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1360.281 645.402)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1365.871 645.402)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1393.82 645.402)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1281.69 645.402)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1287.28 639.812)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1292.87 639.812)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1298.46 639.812)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1304.05 639.812)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1309.64 639.812)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1320.82 639.812)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1326.41 639.812)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.921,
    height: 5.59,
    transform: "translate(1354.36 639.812)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1365.871 639.812)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1377.051 639.812)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1382.641 639.812)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.92,
    height: 5.59,
    transform: "translate(1399.411 639.812)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.59,
    height: 5.59,
    transform: "translate(1281.69 639.812)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1261.019 619.733)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1313.8,1005.6a1.988,1.988,0,0,1-1.988-1.988V976.5a1.988,1.988,0,0,1,1.988-1.988h27.355a1.988,1.988,0,1,1,0,3.976h-25.367v25.123A1.988,1.988,0,0,1,1313.8,1005.6Z",
    transform: "translate(-1311.81 -974.516)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1394.914 619.611)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1738.538,1005.484a1.988,1.988,0,0,1-1.988-1.988V978.13h-25.123a1.988,1.988,0,0,1,0-3.976h27.111a1.988,1.988,0,0,1,1.988,1.988V1003.5A1.988,1.988,0,0,1,1738.538,1005.484Z",
    transform: "translate(-1709.439 -974.153)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1394.671 756.097)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1738.059,1410.563H1710.7a1.988,1.988,0,0,1,0-3.977h25.367v-25.123a1.988,1.988,0,0,1,3.976,0v27.112A1.988,1.988,0,0,1,1738.059,1410.563Z",
    transform: "translate(-1708.716 -1379.475)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1261.019 755.975)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1340.91,1410.444H1313.8a1.988,1.988,0,0,1-1.988-1.988V1381.1a1.988,1.988,0,1,1,3.976,0v25.366h25.124a1.988,1.988,0,0,1,0,3.976Z",
    transform: "translate(-1311.81 -1379.113)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -107)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1273.181 867.136)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.669,0H134.99a5.669,5.669,0,0,1,5.669,5.669v0a5.669,5.669,0,0,1-5.669,5.669H5.668A5.668,5.668,0,0,1,0,5.669v0A5.669,5.669,0,0,1,5.669,0Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1273.102 867.136)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.079)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1446.207,1572.621v11.338H1351.7a3.779,3.779,0,0,1-3.769-3.769v-3.8a3.78,3.78,0,0,1,3.769-3.769Z",
    transform: "translate(-1347.928 -1572.621)",
    fill: "#ed7d2b"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48.643 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1522.17,1572.621l-10.457,11.337h-19.566l10.457-11.337Z",
    transform: "translate(-1492.147 -1572.621)",
    fill: "#f9ae30"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(80.224 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1604.068,1572.621v11.337h-18.134l10.458-11.337Z",
    transform: "translate(-1585.934 -1572.621)",
    fill: "#f9ae30"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.14 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1428.617,1572.621l-10.457,11.337h-19.565l10.457-11.337Z",
    transform: "translate(-1398.595 -1572.621)",
    fill: "#f9ae30"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1363.354,1572.621l-10.457,11.338h-1.434a3.78,3.78,0,0,1-3.769-3.769v-3.8a3.78,3.78,0,0,1,3.769-3.769Z",
    transform: "translate(-1347.694 -1572.621)",
    fill: "#f9ae30"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrPhone);
export default __webpack_public_path__ + "static/media/qr-phone.ea3e9facfc20127b1207600ddbfd7a91.svg";
export { ForwardRef as ReactComponent };